import React from 'react';
import { TableCell, TableCellProps, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { colors } from '../../utils/theme';

//       NOT USED IN SCROLL GRID RIGHT NOW

interface Props extends TableCellProps {
  showBorder?: boolean;
}

const useStyles = makeStyles<{ showBorder?: boolean }>()((theme: Theme, props) => ({
  head: {
    backgroundColor: 'transparent',
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.peacockBlue,
    borderWidth: 2,
    // borderColor: colors.navyBlue,
  },
  body: {
    fontSize: 18,
    borderColor: colors.navyBlue,
    borderBottom: props.showBorder ? '1px solid' : 'none',
    maxWidth: 300,
  },
}));

const LPTableCell: React.FC<Props> = props => {
  const { showBorder, ...rest } = props;
  const { classes } = useStyles(props);

  return (
    <TableCell classes={{ head: classes.head, body: classes.body }} {...rest}>
      {props.children}
    </TableCell>
  );
};

export default LPTableCell;
